export default "__VITE_ASSET__Cpc_4hcg__"